'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Severity = function () {
  function Severity() {
    var _this = this;

    _classCallCheck(this, Severity);

    var severities = {
      CRITSIT: { id: 0, priority: 4 },
      OUTAGE: { id: 1, priority: 3 },
      MAINTENANCE: { id: 2, priority: 2 },
      DEBUG: { id: 3, priority: 1 }
    };

    this.idIndex = {};

    Object.keys(severities).forEach(function (key) {
      var value = severities[key];
      _this[key] = value;
      value.key = key;

      _this.idIndex[value.id] = value;
    });
  }

  _createClass(Severity, [{
    key: 'getById',
    value: function getById(id) {
      return this.idIndex[id];
    }
  }, {
    key: 'getByKey',
    value: function getByKey(key) {
      return this[key];
    }
  }]);

  return Severity;
}();

exports.default = new Severity();
module.exports = exports['default'];